import { AnswerType } from "modules/NewClientSurvey/common/constants"

export function checkIsInput(type: AnswerType) {
    return type === AnswerType.number || type === AnswerType.short_text
}
